// extracted by mini-css-extract-plugin
export var list = "tag-list-module--list--FaqOT";
export var item = "tag-list-module--item--1nid9";